import { Injectable } from '@angular/core';
import { AuthorizationCodeRequestConfigurationService } from '../../configuration/auth/authorization-code-request-configuration/authorization-code-request-configuration.service';
import { BasicAuthHeaderFactoryService } from '../../http/headers/basic-auth-header-factory.service';
import { ContentTypeHeaderFactoryService } from 'src/app/shared/http/headers/content-type-header-factory.service';
import { SuperBatmanHeaderFactoryService } from 'src/app/shared/http/headers/super-batman-header-factory.service';
import { HeaderArrayToHttpHeadersConversionService } from 'src/app/shared/http/headers/header-array-to-http-headers-conversion.service';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class AuthorizationCodeRequestHeadersFactoryService {

  get authorizationCodeRequestConfiguration() {
    return this.authorizationCodeRequestConfigurationService.configuration;
  }

  get contentType() {
    return this.authorizationCodeRequestConfiguration.contentType;
  }

  get addBasicAuthHeader() {
    return this.authorizationCodeRequestConfiguration.addBasicAuthHeader;
  }

  constructor(private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private contentTypeHeaderFactoryService: ContentTypeHeaderFactoryService,
    private superBatmanHeaderFactoryService: SuperBatmanHeaderFactoryService,
    private basicAuthHeaderFactoryService: BasicAuthHeaderFactoryService,
    private headerArrayToHttpHeadersConversionService: HeaderArrayToHttpHeadersConversionService) { }

  createHeaders() {
    const httpHeaderArray = this.createHeadersArray();
    return this.headerArrayToHttpHeaders(httpHeaderArray);
  }

  createContentTypeHeader() {
    return this.contentTypeHeaderFactoryService.createHeader(this.contentType);
  }

  createSuperBatmanHeader() {
    return this.superBatmanHeaderFactoryService.createHeader();
  }

  createBasicAuthHeader() {
    return this.basicAuthHeaderFactoryService.createHeader();
  }

  createHeadersArray() {
    const headerArray = [];
    const contentTypeHeader = this.createContentTypeHeader();
    headerArray.push(contentTypeHeader);
    if (this.addBasicAuthHeader) {
      const basicAuthHeader = this.createBasicAuthHeader();
      headerArray.push(basicAuthHeader);
    }
    return headerArray;
  }

  headerArrayToHttpHeaders(array) {
    return this.headerArrayToHttpHeadersConversionService.run(array);
  }
}
